export default {
    MAX_RESULTS_RETURNED: 'Max number of lists returned. Please use the search to filter.',
};
